// extracted by mini-css-extract-plugin
module.exports = {"container":"PKWjox4JMKZ7u6Qx2iJKY"};